export const SET_DENTAL = 'dental/SET_DENTAL';
